interface VersionInfo {
  major: number;
  minor: number;
  patch: number;
  environment: string;
}

export function parseVersion(versionString: string): VersionInfo {
  // Default to 0.0.0 if no version string
  const defaultVersion = { major: 0, minor: 0, patch: 0 };

  if (!versionString) return { ...defaultVersion, environment: "local" };

  // Remove 'v' prefix if exists and split version numbers
  const numbers = versionString.replace("v", "").split(".");

  return {
    major: parseInt(numbers[0]) || 0,
    minor: parseInt(numbers[1]) || 0,
    patch: parseInt(numbers[2]) || 0,
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT || "local",
  };
}

export const version = parseVersion(
  process.env.NEXT_PUBLIC_APP_VERSION || "0.0.0"
);

export function getEnvironmentColor(env: string) {
  switch (env) {
    case "production":
      return "bg-green-100 text-green-800";
    case "development":
      return "bg-yellow-100 text-yellow-800";
    case "local":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}

export function formatVersion(version: VersionInfo): string {
  return `v${version.major}.${version.minor}.${version.patch}`;
}
